import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

export interface ReleaseNotesData {
  version: string;
  items: string[];
}

@Component({
  selector: 'app-release-notes-dialog',
  templateUrl: './release-notes-dialog.component.html',
  styleUrls: ['./release-notes-dialog.component.scss']
})
export class ReleaseNotesDialogComponent {

  @Input() data!: ReleaseNotesData;
  @Output() closed = new EventEmitter<void>();

  constructor(private cookieService: CookieService) {}

  acknowledge() {
    this.cookieService.set(
      'releaseNotesSeenVersion',
      this.data.version,
      { expires: 30 }
    );

    this.closed.emit();
  }
}
